const quotes = [
  {
    text: 'There is no magic. There is only knowledge, more or less hidden.',
    author: 'Gene Wolfe',
  },
  {
    text: 'All we hold dear is hanging by a thread, and every haven that we fabricate can only be an intermittent space.',
    author: 'Robin Staps',
  },
  {
    text:
      'Those who are capable of tyranny are capable of perjury to'
      + ' sustain it.',
    author: 'Lysander Spooner',
  },
  {
    text:
      'The only thing that makes life possible is permanent,'
      + ' intolerable uncertainty.',
    author: 'Ursula Le Guin',
  },
  {
    text: 'How can anyone read history and still trust politicians?',
    author: 'Thomas Sowell',
  },
  {
    text:
      'There can be no truly moral choice unless that choice '
      + ' is made in freedom.',
    author: 'Murray Rothbard',
  },
  {
    text: 'He who is unfit to serve his fellow citizens wants to rule them.',
    author: 'Ludwig von Mises',
  },
  {
    text: 'Poverty can be brought about by law; it cannot be forbidden by law.',
    author: 'Isabel Paterson',
  },
  {
    text:
      'Part of freedom is the right of each of us to go to hell'
      + ' in his own fashion.',
    author: 'David D. Friedman',
  },
  {
    text:
      'Government is the great fiction through which everybody '
      + ' endeavors to live at the expense of everybody else.',
    author: 'Frédéric Bastiat',
  },
  {
    text:
      'Living is fighting for life, and when anyone does not know'
      + ' this fact, someone else is doing his fighting for him.',
    author: 'Rose Wilder Lane',
  },
  {
    text:
      'Just as war is the natural consequence of monopoly, peace'
      + ' is the natural consequence of liberty.',
    author: 'Gustave de Molinari',
  },
];

export default quotes;
